import type { ArgsProps } from 'antd/lib/notification';
import { type ThemeNotificationApi } from '../makeNotificationApi';

const TOAST_TAG = 'p-toast';

type NotificationConfig = {
    content: React.ReactNode;
} & Omit<ArgsProps, 'message'>;

type ToastElement = HTMLDivElement & {
    addMessage: (message: { text: string; state: 'success' | 'info' }) => void;
};

// TODO: this implementation is not ideal, but it is compatible with the `ThemeNotificationApi` interface
// the ideal way is to use the `useToastManager` hook Porsche react
const showToast = (text: string | NotificationConfig, type: 'success' | 'info') => {
    const toasts = document.querySelectorAll<ToastElement>(TOAST_TAG);

    if (!toasts || toasts.length === 0) {
        return;
    }

    toasts.forEach(toast => {
        toast?.addMessage({
            text: typeof text === 'object' ? (text.content as string) : text,
            state: type,
        });
    });
};

const notification: ThemeNotificationApi = {
    loading: (text: string | NotificationConfig) => showToast(text, 'info'),
    destroy: (text: string) => {},
    error: (text: string) => showToast(text, 'info'),
    success: (text: string) => showToast(text, 'success'),
    info: (text: string) => showToast(text, 'info'),
    warn: (text: string) => showToast(text, 'info'),
};

export default notification;
